import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Hero from "@/components/Hero";
import MarqueeStrip from "@/components/MarqueeStrip";
import Services from "@/components/Services";
import SavingsCalculator from "@/components/SavingsCalculator";
import Reviews from "@/components/Reviews";
import Manifesto from "@/components/Manifesto";
import About from "@/components/About";
import Contact from "@/components/Contact";

export default function Home() {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const t = setTimeout(() => document.querySelector(hash)?.scrollIntoView(), 400);
      return () => clearTimeout(t);
    }
  }, [hash]);

  return (
    <main>
      <Hero />
      <MarqueeStrip />
      <Services />
      <SavingsCalculator />
      <Reviews />
      <Manifesto />
      <About />
      <Contact />
    </main>
  );
}
